import PercentageBar from "./percentage-bar";

export default PercentageBar;
